


























































































import Vue from 'vue';
import moment from 'moment-timezone';

import IfEmptyTextPrintNA from '../IfEmptyTextPrintNA.vue';
import { Ultrassom } from '../../../../back/src/entity/Ultrassom';
import { Gestacao } from '../../../../back/src/entity/Gestacao';
import {
  sexoBebeItens,
  normalAlteradoStrings,
  apresentacaoFetalStrings,
  placentaLocalizacaoStrings,
} from '../../utils/constants';
import { ApresentacaoFetal, NormalAlterado } from '../../../../back/src/types';

export default Vue.extend({
  name: 'TheUltrassomDados',
  components: {
    IfEmptyTextPrintNA,
  },
  props: {
    ultrassom: {
      type: Object as () => Ultrassom,
    },
    gestacao: {
      type: Object as () => Gestacao,
    },
  },
  data() {
    return {
    };
  },
  computed: {
    vRowClass(): string {
      if (this.$vuetify.breakpoint.xsOnly) {
        return 'd-flex flex-column';
      }
      return '';
    },
    idadeGestacional(): string {
      let igString = '';
      if (this.ultrassom.ig_semanas !== null && this.ultrassom.ig_semanas > 0) {
        igString = igString.concat(`${this.ultrassom.ig_semanas}`);
      }
      if (this.ultrassom.ig_dias !== null && this.ultrassom.ig_dias > 0) {
        igString = igString.concat(` ${this.ultrassom.ig_dias}/7  semanas`);
      } else if (igString.length > 0) {
        igString = igString.concat(' semanas');
      }
      return igString;
    },
    placenta(): string | null {
      let placentaString = '';
      if (this.ultrassom.placenta_localizacao !== null) {
        placentaString = `${placentaLocalizacaoStrings[this.ultrassom.placenta_localizacao]}`;
      }
      if (this.ultrassom.placenta_grau !== null) {
        placentaString = placentaString.concat(`, grau ${this.ultrassom.placenta_grau}`);
      }
      return placentaString || null;
    },
    gemelar() {
      return this.gestacao.gestacao_gemelar;
    },
  },
  methods: {
    apresentacaoString(apresentacao: ApresentacaoFetal | null): string | null {
      if (apresentacao !== null) {
        return apresentacaoFetalStrings[apresentacao];
      }
      return null;
    },
    normalAlteradoString(val: NormalAlterado): string | null {
      if (val !== null) {
        return normalAlteradoStrings[val];
      }
      return null;
    },
    pesoFormatado(pesoGramas: number): string | null {
      if (pesoGramas) {
        return `${new Intl.NumberFormat('pt-BR').format(pesoGramas)}`;
      }
      return null;
    },
  },
});
